import React, { Component } from "react";
import "./MainMenuOptions.scss";
import flashcardIcon from "../../../assets/images/lightbulb_icon.png";
import fastQuizIcon from "../../../assets/images/whistle_icon.png";
import repeatQuizIcon from "../../../assets/images/loop_icon.png";
import testKnowledgeIcon from "../../../assets/images/checkered_flag_icon.png";
import { NavLink } from "react-router-dom";

const difficultyLevels = {
  E: "Easy",
  M: "Medium",
  H: "Hard",
  A: "All",
};
class MainMenuOptions extends Component {
  getDifficultyText = (diff) => {
    if (diff === "A") {
      return "All Difficulties";
    } else {
      return difficultyLevels[diff] + " Difficulty";
    }
  };
  getQuestionsText = (questions) => {
    if (parseInt(questions) === 0) {
      return "All Questions";
    } else {
      return questions + " Questions";
    }
  };
  render() {
    const { existingCookie } = this.props;
    const menuOptions = [
      {
        id: 1,
        title: "Flashcards",
        sub_title: "Review Questions and Content",
        link: "/flashcards-difficulty",
        iconurl: flashcardIcon,
      },
      {
        id: 2,
        title: "Fast Quiz",
        sub_title: "Practice on a Random Set of Questions",
        link: "/fastquiz-difficulty",
        iconurl: fastQuizIcon,
      },
      {
        id: 3,
        title: "Fast Quiz Same Settings",
        sub_title:
          existingCookie && existingCookie.quiz_settings.diff
            ? this.getQuestionsText(existingCookie.quiz_settings.questions) +
              " @ " +
              this.getDifficultyText(existingCookie.quiz_settings.diff)
            : "",
        link: {
          pathname: "/fastquiz",
          state: { showQuiz: "1" },
        },
        iconurl: repeatQuizIcon,
      },
      // FLAG-DEBUG-ISTESTFLAG     
      // TODO - Temp comment for PI
      // TODO - Change to test content page with a PI note...?
      // Show current logged in values here with confirm button to begin
      // If PI class, then show PI instructions as well...
      // TODO - Add note and skip MIX and MMG question types in full test!!!
      {
        id: 4,
        title: "Test Your Knowledge",
        sub_title: " All Questions @ All Difficulties",
        link: "/knowledge-test",
        iconurl: testKnowledgeIcon,
      },
  ];

    return (
      <div className="menu-options-container">
        <div className="options-list">
          {menuOptions.map((option, index) => {
            return (
              <NavLink
                className={
                  "single-option" + (option.sub_title === "" ? " disabled" : "")
                }
                // to={`${process.env.PUBLIC_URL}` + option.link}
                to={option.link}
                key={"option_" + index}
              >
                <div className="option-glyghtextarea">
                  <div className="option-glyph">
                    <img src={option.iconurl} alt="" height="32" width="32" />
                  </div>
                  <div className="option-textarea">
                    <div className="option-title">{option.title}</div>
                    <div className="option-subtitle">{option.sub_title}</div>
                  </div>
                </div>
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }
}

export default MainMenuOptions;
